import { setCookie, getCookie, eraseCookie } from './cookies';

const cookieActive = getCookie('_subs_form');

$(window).on('load', function() {
	setTimeout(function() {
		// callPopup();
	}, 10000);
});
function callPopup() {
	const $submitCookie = $('.rf-form');
	const $closeBtn = $('.js-popup-close');

	if (!cookieActive) {
		$('body').addClass('show-newsletter');
	}

	$submitCookie.on('submit', function() {
		setCookie('_subs_form', 'email', 3);
		$('body').removeClass('show-newsletter');
	});

	$closeBtn.on('click', function(event) {
		event.preventDefault();
		setCookie('_subs_form', 'email', 3);
		$('body').removeClass('show-newsletter');
	});
}
